// Neutral bundled shape for the Manufacturer Banking Information
// "Exhibit B". This is a STRUCTURE ONLY — it deliberately carries no
// company, bank, or account data.
//
// Banking details are tenant-confidential and must arrive exclusively from
// the per-org `manufacturer-banking` template (useTemplate). A bundled
// default is shared by every org on the same frontend build, so any real
// value placed here would be one tenant's banking shown to its competitors.

let cached = null;

export function getManufacturerBankingDefault() {
  if (cached != null) return cached;
  cached = {
    ach: {
      companyName: "",
      bankName: "",
      bankAddress: "",
      beneficiaryName: "",
      routingNumber: "",
      accountNumber: "",
      companyAddress: "",
    },
    check: {
      companyName: "",
      mailingAddress: "",
    },
  };
  return cached;
}

const nonEmpty = ([, v]) => v != null && String(v).trim() !== "";

// The [label, value] rows every banking surface renders, in one place.
// Three surfaces used to derive these independently — the on-screen
// accordion, the PSA PDF, and the NAF PDF — so "is this org configured?"
// had three answers and only one of them was ever tested.
export function buildAchRows(banking) {
  const ach = (banking && typeof banking === "object" && banking.ach) || {};
  return [
    ["Company Name", ach.companyName],
    ["Bank Name", ach.bankName],
    ["Bank Address", ach.bankAddress],
    ["Beneficiary Name", ach.beneficiaryName],
    ["Routing Transit Number", ach.routingNumber],
    ["Beneficiary Account Number", ach.accountNumber],
    ["Company Address", ach.companyAddress],
  ].filter(nonEmpty);
}

export function buildCheckRows(banking) {
  const check = (banking && typeof banking === "object" && banking.check) || {};
  return [
    ["Company Name", check.companyName],
    ["Company Mailing Address", check.mailingAddress],
  ].filter(nonEmpty);
}

// True only when the org has actually configured banking. Render surfaces
// use this to show a "not configured" state; PDF generators use it to omit
// Exhibit B entirely rather than emit an empty or foreign banking block.
export function isBankingConfigured(banking) {
  return buildAchRows(banking).length > 0 || buildCheckRows(banking).length > 0;
}

export default getManufacturerBankingDefault;
